export default "__VITE_ASSET__DrVn3Xhl__"